import { useTranslation } from 'react-i18next';
import { useGetRepaymentSchedule } from '@/query/queries/cash/useGetRepaymentSchedule';
import { Row } from './row';
import s from './index.module.scss';

export const FutureRepayments = () => {
  const { data: schedule } = useGetRepaymentSchedule({ page: 1, limit: 20 });
  const { t } = useTranslation('next-repayment');

  if (!schedule?.list) return null;

  return (
    <div className={s.wrapper}>
      <div className="f-h3 f-500">{t('future_repayments.future_repayments')}</div>
      <div className={s.list}>
        {schedule?.list.map(item => (
          <Row data={item} key={item.deadline} />
        ))}
      </div>
    </div>
  );
};
